import { BackendApiClient } from '../api-client';

/**
 * GET /azdance/:slug - Event with packages, spectator tickets, milongas, workshops, etc.
 */
export async function fetchAztangofestEvent(slug: string, language: string) {
  return BackendApiClient.AzdanceService.azdanceControllerGetEvent({ slug, language });
}
